angular.module('ikeweb.spike.capture').factory('spikeImageService', ['$q', function spikeImageService($q) {
    return {
        setImageSrc: function(imageElement, url) {
            var deferred = $q.defer();

            imageElement.src = url;

            if (imageElement.complete) {
                // Chrome and Firefox will set image immeditaly if the image is already loaded elsewhere on the page
                deferred.resolve(imageElement);
            } else {
                function fulfil() {
                    imageElement.removeEventListener('load', fulfil);
                    imageElement.removeEventListener('error', fulfil);

                    if (imageElement.naturalWidth) {
                        deferred.resolve(imageElement);
                    } else {
                        deferred.reject('Image failed to load');
                    }
                }

                imageElement.addEventListener('load', fulfil);
                imageElement.addEventListener('error', fulfil);
            }

            return deferred.promise;
        }
    };
}]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/image.service.js
// module id = 579
// module chunks = 0